let audioRef = new Audio();
let onEndCallback = null;
let currentStepId = null;

export const useAudioPlayer = () => {
  const play = (url, stepId, onEnd) => {
    if (audioRef.src === url && !audioRef.paused) {
      audioRef.pause();
      onEndCallback?.();
      return 'paused';
    }

    audioRef.pause();
    audioRef.currentTime = 0;
    audioRef.src = url;
    currentStepId = stepId;
    onEndCallback = onEnd;
    audioRef.play();
    return 'playing';
  };

  const pause = () => {
    audioRef.pause();
    onEndCallback?.();
  };

  return {
    play,
    pause,
    getCurrentStepId: () => currentStepId,
  };
};
